import domReady from "@wordpress/dom-ready";
import { createRoot } from "@wordpress/element";
import "../src/css/home-form.css";
import HomeForm from "./components/HomeForm/HomeForm";


if (document.getElementById("home-search-form")) {

  domReady(() => {
    const root = createRoot(
      document.getElementById("home-search-form"),
    );
    root.render(<HomeForm />);
  });
}